import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMetricsColorPavilion = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m22.836 26.754.797 18.477-14.386-5.959zM38.753 39.273 24.367 45.23l.77-18.467zM21.227 25.12l-12.5 13.633L2.77 24.367zM39.273 38.753 26.767 25.13l18.464-.763zM21.227 22.88l-18.458.753L8.728 9.247zM45.231 23.633l-18.464-.764L39.273 9.247zM38.753 8.728 25.148 21.24l-.78-18.471zM22.978 21.19 9.248 8.729l14.385-5.96z" })
});
export default SvgMetricsColorPavilion;
